<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-01 21:02:37
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-01-14 18:21:31
-->
<template>
  <v-card>
    <mrc_ess_skeleton_loader :loading="$store.state.uuid ? skeletonloading : false">
      <v-card-text>
        <v-row>
          <v-col cols="12"
                 sm="6"
                 class="d-flex">
            <v-row>
              <v-col cols="12">
                <mrc_ess_datePicker @getTime="paramsChange"
                                    :disabled="disabled"
                                    :label="$t('label_Date_of_birth')"
                                    v-model="stafflist.date_of_brith"></mrc_ess_datePicker>
              </v-col>
              <v-col cols="12">
                <!-- 员工婚姻状态 -->
                <!-- :errMsg="$errors('stafflist','maritual_status',requiredRule)" -->
                <mrc_ess_dictName v-model="stafflist.maritual_status"
                                  :disabled="disabled"
                                  :label="$t('label_Marital_status')"
                                  :rules="false"
                                  :chips="false"
                                  :isNational="judegNational('maritual_status')"
                                  dict_name="marital_status"></mrc_ess_dictName>
              </v-col>
            </v-row>
          </v-col>
          <!-- 性别 -->
          <v-col cols="12"
                 sm="6"
                 v-if="!disabled">
            <div class="left text--secondary"
                 style="font-size:12px;">
              {{ $t('label_Gender') }}
            </div>
            <v-radio-group v-model="stafflist.gender"
                           style="position:relative;top:-12px;font-size:12px; color: rgba(0, 0, 0, 0.6); font-weight: 400;"
                           row>
              <v-radio :label="INT(item.dict_label)"
                       style="margin-right:80px;"
                       :key="index"
                       v-for="(item, index) in sexList"
                       :value="INT(item.dict_value)">
              </v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12"
                 sm="6"
                 style="margin-top:3.5px;"
                 v-else>
            <!--   :errMsg="$errors('stafflist','gender',requiredRule)" -->
            <mrc_ess_dictName v-model="stafflist.gender"
                              :disabled="disabled"
                              :chips="false"
                              :label="$t('label_Gender')"
                              :rules="false"
                              :isNational="judegNational('gender')"
                              dict_name="gender">
            </mrc_ess_dictName>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12"
                 sm="6">
            <mrc_ess_phoneInput :readonly="disabled"
                                label=""
                                v-model="stafflist.mobile_number"
                                :changeCode.sync="stafflist.mobile_number_area_code"
                                :code="stafflist.mobile_number_area_code">
            </mrc_ess_phoneInput>
          </v-col>
          <v-col cols="12"
                 sm="6">
            <mrc_ess_phoneInput :readonly="disabled"
                                label=""
                                v-model="stafflist.home_number"
                                :changeCode.sync="stafflist.home_number_area_code"
                                :code="stafflist.home_number_area_code">
            </mrc_ess_phoneInput>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12"
                 sm="6">
            <!-- -->
            <mrc_ess_multiText :label="$t('label_Personal_mailbox')"
                               :isNational="judegNational('persona_email_address')"
                               :readonly="disabled"
                               :error-messages="
                $errors('stafflist', 'persona_email_address', emailRule)
              "
                               v-model="stafflist.persona_email_address">
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12"
                 sm="6">
            <!---->
            <mrc_ess_input :label="$t('label_Fax_number')"
                           :readonly="disabled"
                           :error-messages="$errors('stafflist', 'fax', numericRule)"
                           v-model.number="stafflist.fax">
            </mrc_ess_input>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12"
                 class="d-flex justify-space-between">
            <div class="text--secondary text-h5 d-flex align-center">
              {{ $t('label_address') }}
            </div>
            <mrc_ess_textAddBtn v-if="!disabled"
                                left
                                :textstatus='false'
                                color='white'
                                @click="editItem"
                                :text="$t('label_New_address')"></mrc_ess_textAddBtn>
          </v-col>
        </v-row>

        <v-card v-for="(item, index) in mrbase_sys_staff_address"
                :key="index"
                style="border:1px solid #eeeef0"
                class="mt-6">
          <v-card-text>
            <div class="addresscard">
              <div class="d-flex align-center">
                <mrc_ess_viewbtn :is_used="item.status"
                                 class="mr-4"></mrc_ess_viewbtn>
                <span class="text-h7 text--secondary">
                  {{ $t('label_address') }}{{ index + 1 }}
                </span>
              </div>
              <div v-if="!disabled">
                <v-icon class="mr-4"
                        @click="editItem(item)">
                  mdi-pencil
                </v-icon>
                <v-icon @click="deleteItem(item)">
                  mdi-delete
                </v-icon>
              </div>
            </div>
            <mrc_ess_multiText :label="$t('label_address') + '*'"
                               v-model="item.address_line_1"
                               :readonly="true">
            </mrc_ess_multiText>
            <mrc_ess_multiText class="mt-n6"
                               :readonly="true"
                               v-model="item.address_line_2">
            </mrc_ess_multiText>
            <mrc_ess_multiText class="mt-n6"
                               :readonly="true"
                               v-model="item.address_line_3">
            </mrc_ess_multiText>
          </v-card-text>
        </v-card>
      </v-card-text>
      <mrc_ess_submitBtn @success="success"
                         @cancel="cancel"
                         :loading="btnIsLoading"
                         v-if="!disabled"></mrc_ess_submitBtn>
      <mrc_ess_myDialog v-model="dialog"
                        :title="$t('label_address')"
                        @success="save"
                        @cancel="close">
        <v-card-text class="pa-0">
          <mrc_ess_multiText :label="$t('label_address') + '*'"
                             :error-messages="
              $errors('editedItem', 'address_line_1', requiredRule)
            "
                             :isNational="judegNational('address_line_1')"
                             v-model="editedItem.address_line_1"
                             :readonly="disabled">
          </mrc_ess_multiText>
          <mrc_ess_multiText :readonly="disabled"
                             class="mt-n3"
                             :error-messages="
              $errors('editedItem', 'address_line_2', requiredRule)
            "
                             :isNational="judegNational('address_line_2')"
                             v-model="editedItem.address_line_2">
          </mrc_ess_multiText>
          <mrc_ess_multiText :readonly="disabled"
                             class="mt-n3"
                             :error-messages="
              $errors('editedItem', 'address_line_3', requiredRule)
            "
                             :isNational="judegNational('address_line_3')"
                             v-model="editedItem.address_line_3">
          </mrc_ess_multiText>
          <mrc_ess_datePicker @getTime="paramsChange2"
                              :label="$t('label_Effective_date') + '*'"
                              :disabled="false"
                              :errMsg="
              $errors('editedItem', 'effective_start_date', requiredRule)
            "
                              v-model="editedItem.effective_start_date"></mrc_ess_datePicker>
        </v-card-text>
      </mrc_ess_myDialog>
    </mrc_ess_skeleton_loader>
  </v-card>
</template>

<script>
import { getDataByName } from '@/service/api/data_dictionary.js'
import {
  required,
  maxLength,
  between,
  email,
  url,
  numeric,
} from 'vuelidate/lib/validators'
import {
  getStaffPersonal,
  getStaffPersonalUpdate,
} from '@/service/api/staffmsg.js'
import moment from 'moment'
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      skeletonloading: true,
      btnIsLoading: false,
      dialog: false,
      uuid: '', //唯一标识
      staff_uuid: '', //关联staff表uuid
      stafflist: {},
      sexList: [],
      mrbase_sys_staff_address: [
        //地址信息
      ],
      editedIndex: -1,
      editedItem: {
        address_line_1: '', //地址1
        address_line_2: '', //地址2
        address_line_3: '', //地址3
        effective_start_date: '', //地址有效日期
      },
      defaultItem: {
        address_line_1: '', //地址1
        address_line_2: '', //地址2
        address_line_3: '', //地址3
        effective_start_date: '', //地址有效日期
      },
      deleteAddresss: [], //删除的地址
    }
  },
  created () { },
  async mounted () {
    this.national('mrbase_sys_staff_personal_info')
    getDataByName('gender').then((res) => {
      if (res.code == 200) {
        this.sexList = res.data
      }
    })
    await this.getlist()
  },
  methods: {
    async success () {
      //提交  moment(time).format('YYYY-MM-DD')
      this.$v.stafflist.$touch()
      if (this.$v.stafflist.$error) return
      this.btnIsLoading = true
      const user_id = this.$store.state.detailuuid
      const uuid = this.$store.state.uuid
      this.stafflist.gender = this.stafflist.gender
        ? Number(this.stafflist.gender)
        : ''
      if (this.stafflist.date_of_brith)
        this.stafflist.date_of_brith = moment(
          this.stafflist.date_of_brith
        ).format('YYYY-MM-DD')
      this.mrbase_sys_staff_address.map((item) => {
        if (item.effective_start_date)
          item.effective_start_date = moment(item.effective_start_date).format(
            'YYYY-MM-DD'
          )
      })
      await getStaffPersonalUpdate({
        uuid: uuid,
        user_id: user_id,
        mrbase_sys_staff_personal_info: [
          { ...this.stafflist, staff_uuid: uuid },
        ],
        mrbase_sys_staff_address: [
          ...this.mrbase_sys_staff_address,
          ...this.deleteAddresss,
        ].map((item) => {
          return { ...item, staff_uuid: uuid }
        }),
      }).then(async (res) => {
        if (res.code == 200) {
          this.$Message({
            text: this.$t('message_The_operation_was_successful'),
          })
          await this.getlist()
          this.$emit('changeReadonly')
        }
      })
      this.btnIsLoading = false
    },
    async cancel () {
      await this.getlist()
      this.$emit('changeReadonly')
      // this.$myConfirm({
      //   content: this.$t('message_Confirm_the_cancellation_of_the_edit'),
      // })
      //   .then((res) => {
      //     this.$router.push({
      //       name: 'staffmanagement',
      //     })
      //   })
      //   .catch((err) => { })
    },
    paramsChange () {
      //时间改变获取时间
    },
    paramsChange2 () { },
    editItem (item) {
      this.$v.$reset()
      if (item.uuid || item.address_line_1) {
        //传了item就是修改  没传就是添加
        this.editedIndex = this.mrbase_sys_staff_address.indexOf(item)
        this.editedItem = Object.assign({}, item)
      }
      this.dialog = true
    },
    deleteItem (item) {
      const index = this.mrbase_sys_staff_address.indexOf(item)
      this.$myConfirm({
        content: this.$t('message_Confirm_the_deletion'),
      }).then(() => {
        const dd = this.mrbase_sys_staff_address.splice(index, 1)
        if (dd[0].uuid || dd[0].staff_uuid)
          this.deleteAddresss.push({ ...dd[0], '~type~': 'del' })
      })
    },
    async getlist () {
      this.skeletonloading = true
      const uuid = this.$store.state.uuid
      const res = await getStaffPersonal({ staff_uuid: uuid })
      if (res.code == 200) {
        this.uuid = res.data.uuid
        this.staff_uuid = res.data.staff_uuid //后端未返回字段
        this.stafflist = this.$deletefield(null, res.data)
        this.stafflist.gender = String(this.stafflist.gender)
        this.mrbase_sys_staff_address = res.mrbase_sys_staff_address
          ? res.mrbase_sys_staff_address
          : []
      } else {
      }
      this.skeletonloading = false
    },
    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
    save () {
      this.$v.editedItem.$touch()
      if (this.$v.editedItem.$error) return
      if (this.editedIndex > -1) {
        Object.assign(
          this.mrbase_sys_staff_address[this.editedIndex],
          this.editedItem
        )
      } else {
        this.mrbase_sys_staff_address.push(this.editedItem)
      }
      this.close()
    },
  },
  computed: {
    mobile_number () {
      if (
        this.stafflist.mobile_number_area_code &&
        this.stafflist.mobile_number
      ) {
        return (
          '+' +
          this.stafflist.mobile_number_area_code +
          '\xa0\xa0\xa0' +
          this.stafflist.mobile_number
        )
      } else {
        return ''
      }
    },
    home_number () {
      if (this.stafflist.home_number_area_code && this.stafflist.home_number) {
        return (
          '+' +
          this.stafflist.home_number_area_code +
          '\xa0\xa0\xa0' +
          this.stafflist.home_number
        )
      } else {
        return ''
      }
    },
    sex () {
      // console.log(typeof (this.stafflist.gender));
      if (!this.stafflist.gender) return ''
      return this.stafflist.gender == 1
        ? this.$t('label_man')
        : this.$t('label_woman')
    },
    gender () {
      //性别高级参照
    },
    maritual () {
      //婚姻高级参照
    },
  },
  watch: {},
  validations: {
    stafflist: {
      date_of_brith: {},
      gender: {
        // required
      },
      nationality: {},
      maritual_status: {
        // required
      },
      home_number_area_code: {},
      home_number: {
        // areaRequired (value) {
        //   if (value) {
        //     return this.stafflist.home_number_area_code ? true : false
        //   } else {
        //     return true
        //   }
        // },
        // phoneVerify (value) {
        //   if (!value)
        //     return true
        //   const regex = this.$myVerify.phone
        //   return regex.test(this.stafflist.home_number_area_code + value)
        // }
      },
      mobile_number_area_code: {},
      mobile_number: {
        // areaRequired (value) {
        //   if (value) {
        //     return this.stafflist.mobile_number_area_code ? true : false
        //   } else {
        //     return true
        //   }
        // },
        // phoneVerify (value) {
        //   if (!value)
        //     return true
        //   const regex = this.$myVerify.phone
        //   return regex.test(this.stafflist.mobile_number_area_code + value)
        // }
      },
      fax: {
        numeric,
      },
      corporate_email_address: {
        email,
      },
      persona_email_address: {
        email,
      },
    },
    editedItem: {
      //地址信息
      address_line_1: {
        required,
      },
      address_line_2: {
        required,
      },
      address_line_3: {
        required,
      },
      effective_start_date: {
        required,
      },
    },
  },
}
</script>

<style scoped>
. text--secondary {
  font-size: 20px;
  font-weight: 550;
}

.left {
  text-align: left;
}
.addresscard {
  display: flex;
  align-content: center;
  justify-content: space-between;
}
.sps2 {
  color: #cccccc;
  font-size: 13px;
  padding: 0 10px;
}
</style>
